<script setup>

const props = defineProps({
  isActive: {
		type: Boolean,
		default: false
	}
})

const headerData = reactive({
	scrollPosition: 0,
	scrollMotion: null,
})

const alphabet = ref([...'#abcdefghijklmnopqrstuvwxyz'])
const active = ref('#')
const elNormal = ref(null)
const elFixed = ref(null)
const fixed = ref(false)
const locked = ref(false)

onMounted( () => {
	window.addEventListener('scroll', handleScroll)
});

onUnmounted(() => {
	window.removeEventListener('scroll', handleScroll)
})

const handleScroll = () => {

	let currentScrollPosition = window.scrollY

	if (currentScrollPosition < headerData.scrollPosition) {
		if (currentScrollPosition > 250) {
			headerData.scrollMotion = 'up'
		} else {
			headerData.scrollMotion = 'top'
			locked.value = false
		}
	} else {
			headerData.scrollMotion = 'down'
		}

		headerData.scrollPosition = window.scrollY

	if (!locked.value) {

		if (parseInt(elNormal.value.getBoundingClientRect().top) <= 0) {
			fixed.value = true
		} else {
			fixed.value = false
		}

	}
}

const emit = defineEmits(['startsWith'])

watch(fixed, () => {
  if (fixed.value) {
		locked.value = true
	} else {
		locked.value = false
	}
})

watch(active, () => {
  if (active.value) {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth',
		})
		emit('startsWith', active.value)
	}
})

</script>

<template>
	<div class="collapsible" :class="{ 'is-open ': isActive }">
		<div class="collapsible-inner">
			<div ref="elNormal" class="pt-10 alphabet flex justify-between" :class="[fixed ? 'opacity-0': 'opacity-1']">
				<div
					v-for="letter in alphabet" :key="letter"
					class="letter fvs600 xl:fvs600 text-lg xl:text-2xl cursor-pointer uppercase w-10 h-10 lg:w-8 lg:h-8 xl:w-10 xl:h-10  dark:hover:text-dark dark:hover:bg-light hover:text-light hover:bg-dark flex justify-center items-center"
					:class="[ letter === active ? 'dark:bg-light bg-dark text-light dark:text-dark' : 'dark:text-light' ]"
					@click="active = letter"
				>
					{{ letter }}
				</div>
			</div>
		</div>
		<div 
			ref="elFixed" 
			class="fixed z-20 top-0 py-6 xl:py-10 px-4 xl:px-10 alphabet flex justify-between left-0 right-0 dark:bg-dark bg-white"
			:class="[
				fixed && isActive ? 'opacity-100 pointer-events-auto': 'opacity-0 pointer-events-none',
				headerData.scrollMotion === 'up' ? 'top-[125px]' : 'top-0'
			]"
		>
			<div
				v-for="letter in alphabet" :key="letter"
				class="letter fvs600 xl:fvs600 text-lg xl:text-2xl cursor-pointer uppercase w-10 h-10  dark:hover:text-dark dark:hover:bg-light hover:text-light hover:bg-dark flex justify-center items-center"
				:class="[ letter === active ? 'dark:bg-light bg-dark text-light dark:text-dark' : 'dark:text-light' ]"
				@click="active = letter"
			>
				{{ letter }}
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>

	.collapsible {
		display: grid;
		grid-template-rows: 0fr;
		transition: grid-template-rows 500ms;

		& > .collapsible-inner {
			overflow: hidden;
		}

		&.is-open {
			grid-template-rows: 1fr;
		}
	}

	.alphabet {
		-ms-overflow-style: none;
		scrollbar-width: none;
		overflow-x: scroll;

		&::-webkit-scrollbar {
			display: none;
		}

		&.fixed {
			transition: 1s cubic-bezier(0.390, 0.575, 0.565, 1.000);
		}
	}

	.letter {
		margin-right: 10px;
		flex: 0 0 40px;
		@media (min-width: 768px) {
			margin-right: 0;
			flex: 0 0 auto;
		}
	}

</style>